// For bootstrap 4 and I18N 


import { inject } from 'aurelia-framework'
import { RenderInstruction, ValidateResult } from 'aurelia-validation';
//import { I18N } from "aurelia-i18n";

//@inject(I18N)
export class BootstrapFormRenderer {

	//public constructor(private i18n: I18N) { }

	public render(instruction: RenderInstruction) {
		for (let { result, elements } of instruction.unrender) {
			for (let element of elements) {
				this.remove(element, result);
			}
		}

		for (let { result, elements } of instruction.render) {
			for (let element of elements) {
				this.add(element, result);
			}
		}
	}
   
	public add(element: Element, result: ValidateResult) {
		if (result.valid) {
			if (!element.classList.contains('is-invalid')) {
				element.classList.add('is-valid');
			}
		} else {
			// add the has-error class to the enclosing form-group div
			element.classList.remove('is-valid');
			element.classList.add('is-invalid');

			// add help-block
			const id = `validation-message-${result.id}`;
			let message = document.getElementById(id);
			if (!message) {
				message = document.createElement('div');
				element.parentNode.insertBefore(message, element.nextSibling);
				message.className = 'help-block invalid-feedback';
				message.id = id;
			}
			message.textContent = result.message;// this.i18n.tr(result.message);
			
			
		}
	}

	public remove(element: Element, result: ValidateResult) {
		if (result.valid) {
			if (element.classList.contains('is-valid')) {
				element.classList.remove('is-valid');
			}
		} else {
			// remove help-block
			const message = element.parentElement.querySelector(`#validation-message-${result.id}`);
			if (message) {
				element.parentElement.removeChild(message);

				element.classList.remove('is-invalid');
			}
		}
	}
}